module.exports = __webpack_public_path__ + "img/about_08.9523955b.png";